.root {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
}

.actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 4px;
}
